import { render, staticRenderFns } from "./user-courses-test-validate.vue?vue&type=template&id=77566491&scoped=true&"
import script from "./user-courses-test-validate.vue?vue&type=script&lang=js&"
export * from "./user-courses-test-validate.vue?vue&type=script&lang=js&"
import style0 from "./user-courses-test-validate.vue?vue&type=style&index=0&id=77566491&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77566491",
  null
  
)

export default component.exports